import {
  EDSAcceptancesApi,
  EDSEarlyDeteriorationServicePluginApi,
  type BatchScoreRequestItemDto,
  type ClinicalScoreResultDto,
  type PluginAcceptanceRequest,
  type PluginUdiDto
} from '@/generated'
import { globalApiConfig } from '@/services/telehealthApi/APIConfig'

export class EdsService {
  static readonly edsApi = new EDSEarlyDeteriorationServicePluginApi(globalApiConfig)
  static readonly acceptancesApi = new EDSAcceptancesApi(globalApiConfig)

  static async getUdi(): Promise<PluginUdiDto> {
    return (await EdsService.edsApi.getUdi()).data
  }

  static async getClinicalScore(caseId: string, wardId: string): Promise<ClinicalScoreResultDto> {
    return (await EdsService.edsApi.getClinicalScore(caseId, wardId)).data
  }

  static async getClinicalScoresBatch(
    payload: BatchScoreRequestItemDto[]
  ): Promise<ClinicalScoreResultDto[]> {
    return (await EdsService.edsApi.getClinicalScoresBatch(payload)).data
  }

  static async acceptEdsLimitation(payload: PluginAcceptanceRequest): Promise<void> {
    return (await EdsService.acceptancesApi.accept(payload)).data
  }
}
